export default function Footer() {
  return (
    <div className="flex flex-col items-center justify-center py-6">
      <button
        onClick={() =>
          window.open('https://paynet.my/about-paynet.html', '_blank')
        }>
        Authorised by <span className="font-bold text-blue-600">Pay</span>
        <span className="font-bold text-green-600">Net</span>
      </button>
      <div className="mt-4 flex gap-8">
        <div className="footer-item">
          <a
            href="https://aye-ai.org/privacy-legal/"
            className="font-md underline">
            PRIVACY POLICY
          </a>
        </div>
        <div className="footer-item">
          <a href="https://aye-ai.org/user-tc/" className="font-md underline">
            LEGAL
          </a>
        </div>
        <div className="footer-item">
          <a
            href="https://api.whatsapp.com/send?phone=60162666192"
            className="font-md underline">
            CONTACT US
          </a>
        </div>
      </div>
    </div>
  )
}
